@if (isLoading) {
  <div class="animate-pulse space-y-6" aria-label="Cargando horarios disponibles">
    @for (i of [1, 2]; track i) {
      <div>
        <div class="ts-skel mb-3 h-4 w-20"></div>
        <div class="ts-grid">
          @for (j of [1, 2, 3, 4, 5, 6]; track j) {
            <div class="ts-skel h-12"></div>
          }
        </div>
      </div>
    }
  </div>
} @else if (timeSlotsSignal().length === 0) {
  <div class="ts-empty">
    <p class="ts-empty-title">Este día ya no tiene horarios libres</p>
    <p class="ts-empty-text">Toca “Cambiar día” para ver otra fecha.</p>
  </div>
} @else {
  <div class="space-y-6" role="radiogroup" aria-label="Horarios disponibles">
    @for (group of groupedByPeriod(); track group.label) {
      <section>
        <h3 class="ts-period">
          {{ group.label }}
          <span class="ts-period-count">{{ group.slots.length }} {{ group.slots.length === 1 ? 'horario' : 'horarios' }}</span>
        </h3>
        <div class="ts-grid">
          @for (slot of group.slots; track slot.value) {
            <button
              type="button"
              role="radio"
              (click)="selectTime(slot.value)"
              [attr.aria-checked]="selectedTime === slot.value"
              class="ts-slot"
              [class.is-selected]="selectedTime === slot.value">
              {{ slot.label }}
            </button>
          }
        </div>
      </section>
    }
  </div>
}
